import { Card, Col, Container, Row } from "react-bootstrap";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewProductCategory,
  fetchClearProdcutCategoryFormList,
  fetchEditProductCategory,
  fetchProductCategoryAllFormList,
  fetchProductCategoryList,
} from "../actions/productCategory";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import CollapseRadioButtonsList from "../components/Admin/Reusable/CollapseRadioButtonsList";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ProductCategoryAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  const translateForm = "productCategoryForm";
  const translateModule = "productCategory";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    parentId: 0,
    position: "",
    countryId: "",
    status: "ACTIVE",
    sector: "DEVICE_FOR_HOUSE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [categoryDisabled, setCategoryDisabled] = useState(true);

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { productCategoryDetail, productCategoryAllFormList } = useSelector(
    (state) => state.productCategoryReducer
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "countryId") {
      setCategoryDisabled(false);
      dispatch(fetchProductCategoryAllFormList(value));
    }

    setData((prevState) => ({
      ...prevState,
      [name]: value === "" ? "" : value,
    }));
  };

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
      dispatch(fetchProductCategoryAllFormList(countryFormList[0].id));
    }
  }, [countryFormList]);

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, []);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      dispatch(fetchClearProdcutCategoryFormList());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchProductCategoryList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (productCategoryDetail && id) {
      setData({
        ...data,
        name: productCategoryDetail.name || "",
        parentId:
          productCategoryDetail.parentId == null
            ? 0
            : productCategoryDetail.parentId || "",
        countryId: productCategoryDetail.countryId || "",
        status: productCategoryDetail.status || "ACTIVE",
        sector: productCategoryDetail.sector || "DEVICE_FOR_HOUSE",
        position: productCategoryDetail.position || "",
        createdAt: productCategoryDetail.createdAt || "",
        updatedAt: productCategoryDetail.updatedAt || "",
      });
      if (productCategoryDetail && productCategoryDetail.countryId) {
        dispatch(
          fetchProductCategoryAllFormList(productCategoryDetail.countryId)
        );
      }
    }
  }, [productCategoryDetail, id, dispatch]);

  const clientValidationHandler = () => {
    const { name, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    if (data.parentId == 0) {
      data.parentId = "";
    }

    if (id) {
      data.id = id;
      dispatch(fetchEditProductCategory(data, navigate));
    } else {
      dispatch(createNewProductCategory(data, navigate));
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={productCategoryDetail && productCategoryDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="product-holder-admin-left-side-text">
                            <Row>
                              <Col lg={5} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("categoryForm.name")}
                                  name="name"
                                  value={data.name}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("categoryForm.position")}
                                  name="position"
                                  value={data.position}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControl
                                  fullWidth
                                  size="small"
                                  required
                                  error={errors?.countryId ? true : false}
                                  disabled={countryFormList?.length == 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("categoryForm.country")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.countryId}
                                    label={t("categoryForm.country")}
                                    name="countryId"
                                    onChange={handleInputChange}
                                    size="small"
                                    disabled={id && true}
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  {errors?.countryId && (
                                    <FormHelperText>
                                      {t("categoryForm.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>
                              {data?.parentId == 0 && (
                                <Col lg={4} md={12} xs={12} className="mb-4">
                                  <FormControl
                                    fullWidth
                                    required
                                    size="small"
                                    error={errors?.sector ? true : false}
                                  >
                                    <InputLabel id="demo-simple-select-label">
                                      {t("global.sectorName")}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={data?.sector}
                                      label={t("global.sectorName")}
                                      name="sector"
                                      onChange={handleInputChange}
                                      size="small"
                                    >
                                      <MenuItem value={"DEVICE_FOR_HOUSE"}>
                                        {t("global.DEVICE_FOR_HOUSE")}
                                      </MenuItem>
                                      <MenuItem value={"TV_AUDIO"}>
                                        {t("global.TV_AUDIO")}
                                      </MenuItem>
                                      <MenuItem
                                        value={"DEVICE_FOR_HOUSE_AND_TV_AUDIO"}
                                      >
                                        {t(
                                          "global.DEVICE_FOR_HOUSE_AND_TV_AUDIO"
                                        )}
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t("categoryForm.category")}</Card.Header>
                        <Card.Body>
                          <CollapseRadioButtonsList
                            items={productCategoryAllFormList}
                            name="parentId"
                            value={data.parentId}
                            onChange={handleInputChange}
                            id={id}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ProductCategoryAdd;
